export default __webpack_public_path__ + "static/Vivel_el_cole-a5f87ef8a2eb3ba41777f456974bd7cc.png";